/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

import { PERMISSION_STATE_GRANTED, PERMISSION_STATE_DENIED } from './constants.js';

/**
 * useCamera hook managing camera permission state.
 *
 */
export default async function getCameraAccess(onPermissionChange) {
  try {
    const result = await navigator.permissions.query({ name: 'camera' });
    onPermissionChange(result?.state);
    /* istanbul ignore next reason: not to test */
    result.addEventListener('change', e => {
      onPermissionChange(e?.target?.state);
    });
  } catch (error) {
    const loop = setInterval(async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        stream?.getTracks().forEach(p => p.stop());
        onPermissionChange(PERMISSION_STATE_GRANTED);
        // clear interval, assuming user won't revoke permission once granted
        clearInterval(loop);
      } catch (streamError) {
        onPermissionChange(PERMISSION_STATE_DENIED);
      }
    }, 500);
  }
}
